export default __webpack_public_path__ + "static/media/secondary.c47ee61b.png";